export default { 
    'Home.CreateBtn':'添加文档',
    'Home.Menu1':'个人空间',
    'Home.Logout':'退出登录',
    'Home.Logout.Model.title': '提示',
    'Home.Logout.Model.text':'退出登录',
    'Home.Logout.Model.content':'是否退出登录？',
    'Home.Logout.Model.okText':'确定',
    'Home.Logout.Model.cancelText':'取消',
}